<template>
  <v-img max-width="250" v-bind="$attrs" :src="baseUrl + 'logo-original-white.png'" contain></v-img>
</template>

<script>
export default {
  computed: {
    baseUrl() {
      return process.env.BASE_URL;
    },
  },
};
</script>

<style>
</style>